export default __webpack_public_path__ + "static/media/groundplan_d_84a.fee3040b.png";